/**
 * Загрузка обзора для админки разработчиков.
 */

import { useEffect, useState } from "react";
import { API_BASE_URL } from "../config/constants";
import { clearDevToken } from "../utils/devAuth";

function useDevOverview(token, onLogout) {
    const [overview, setOverview] = useState(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;

        const load = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${API_BASE_URL}/dev/overview`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const data = await response.json().catch(() => ({}));

                if (response.status === 401) {
                    clearDevToken();
                    onLogout();
                    return;
                }

                if (!response.ok) {
                    throw new Error(data.error || "Failed to load overview");
                }

                if (!cancelled) {
                    setOverview(data);
                    setError("");
                }
            } catch (err) {
                console.error("Ошибка загрузки админки:", err);
                if (!cancelled) {
                    setError(err.message || "Failed to load overview");
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };

        load();
        return () => {
            cancelled = true;
        };
    }, [token, onLogout]);

    return { overview, error, loading };
}

export default useDevOverview;
// hooks/useDevOverview.js
